import React, { Fragment, Component } from 'react'

import idx from 'idx'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Redirect } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles'

import Tabs from 'components/molecules/Tabs'
import PageWrapper from 'templates/PageWrapper'

import { isCurrentURL } from 'utils/routes'
import * as userActions from 'actions/userActions'
import * as routeActions from 'actions/routeActions'

const styles = theme => ({
  root: {
    display: 'flex',
    marginTop: theme.spacing(6),
  },
  menu: {
    position: 'relative',
    width: 180,
    marginTop: theme.spacing(1),
  },
  inkbar: {
    top: 0,
    left: -32,
    width: 2,
    height: 32,
    position: 'absolute',
    transition: 'all .3s ease',
    backgroundColor: theme.palette.primary.main,
  },
  content: {
    flex: 1,
  },
})

class Sidebar extends Component {
  state = {
    dashSize: false,
  };

  shouldComponentUpdate(nextProps) {
    return (
      idx(nextProps, _ => _.location.pathname) !==
      (idx(this.props, _ => _.location.pathname) || true)
    )
  }

  onTabClick = (tab) => {
    const { location, router } = this.props
    const path = location
      ? location.pathname
      : idx(router, _ => _.location.pathname)

    if (path && tab.path && path !== tab.path) {
      this.props.actions.redirect(tab.path)
    }
  };

  render() {
    const {
      classes,
      children,
      router,
      headerComponent: HeaderComponent,
    } = this.props

    const childPaths = children.map(item => item.props.path)
    const currentURL = children.find((path) => {
      return isCurrentURL(path.props.path, router.location.pathname)
    })

    if (currentURL) {
      const activeItem = childPaths.indexOf(currentURL.props.belongsTo || currentURL.props.path)
      const inkyPosition = (activeItem * 53) - 6

      const links = children.map((item) => {
        return { ...item.props }
      })

      return (
        <Fragment>
          {HeaderComponent && (
            <HeaderComponent currentURL={currentURL.props.path} />
          )}
          <PageWrapper>
            <section className={classes.root}>
              {activeItem === -1 && (
                <Redirect to={{ pathname: children[0].props.path }} />
              )}
              <div className={classes.menu}>
                <Tabs
                  column
                  items={links}
                  currentTab={childPaths[activeItem]}
                  onTabClick={this.onTabClick}
                />
                <div className={classes.inkbar} style={{ top: inkyPosition }} />
              </div>
              <div key={router.location.pathname} className={classes.content}>
                {children}
              </div>
            </section>
          </PageWrapper>
        </Fragment>
      )
    }
    return <Redirect to={{ pathname: childPaths[0] }} />
  }
}

Sidebar.propTypes = {
  size: PropTypes.object,
  router: PropTypes.object,
  children: PropTypes.node,
  classes: PropTypes.object,
  actions: PropTypes.object,
  location: PropTypes.object,
  headerComponent: PropTypes.any,
}

function mapStateToProps(state) {
  return state
}

function mapDispatchToProps(dispatch) {
  const actions = Object.assign({}, userActions, routeActions)
  return {
    actions: bindActionCreators(actions, dispatch),
  }
}

const SidebarComponent = withStyles(styles)(Sidebar)

export default connect(mapStateToProps, mapDispatchToProps)(SidebarComponent)



// WEBPACK FOOTER //
// ./src/containers/core/Sidebar/index.js